// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_singleSpeakerWrapper__Ee4FZ {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: space-between;
  padding: 0 4px;
}
.styles_singleSpeakerWrapper__Ee4FZ .styles_speakerInfo__62iG- {
  display: flex;
  flex: 1 1;
  gap: 4px;
  align-items: center;
  line-height: 1.4;
}
.styles_singleSpeakerWrapper__Ee4FZ .styles_speakerInfo__62iG- .styles_image__F9mug {
  width: 18px;
}
.styles_singleSpeakerWrapper__Ee4FZ .styles_speakerInfo__62iG- .styles_speakerNameInput__XbBSH {
  border-radius: 0.5em;
  border: 1px solid #7c7676;
  width: 100%;
  padding: 4px 2px;
}
.styles_singleSpeakerWrapper__Ee4FZ .styles_speakerInfo__62iG- .styles_speakerNameInput__XbBSH:focus {
  border-color: #6ba7a8;
  outline: none;
}
.styles_singleSpeakerWrapper__Ee4FZ .styles_speakerActions__bkCeC {
  display: flex;
  gap: 8px;
  align-items: center;
}
.styles_singleSpeakerWrapper__Ee4FZ .styles_edit__LpPdc,
.styles_singleSpeakerWrapper__Ee4FZ .styles_delete__8JLdY {
  width: 16px;
}
.styles_singleSpeakerWrapper__Ee4FZ .styles_edit__LpPdc:hover,
.styles_singleSpeakerWrapper__Ee4FZ .styles_delete__8JLdY:hover {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/reusable/SingleTranscript/SpeakerList/SingleSpeaker/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,8BAAA;EACA,cAAA;AACF;AACE;EACE,aAAA;EACA,SAAA;EACA,QAAA;EACA,mBAAA;EACA,gBAAA;AACJ;AAAI;EACE,WAAA;AAEN;AACI;EACE,oBAAA;EACA,yBAAA;EACA,WAAA;EACA,gBAAA;AACN;AACM;EACE,qBAAA;EACA,aAAA;AACR;AAIE;EACE,aAAA;EACA,QAAA;EACA,mBAAA;AAFJ;AAIE;;EAEE,WAAA;AAFJ;AAII;;EACE,eAAA;AADN","sourcesContent":[".singleSpeakerWrapper {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  justify-content: space-between;\n  padding: 0 4px;\n\n  .speakerInfo {\n    display: flex;\n    flex: 1;\n    gap: 4px;\n    align-items: center;\n    line-height: 1.4;\n    .image {\n      width: 18px;\n    }\n\n    .speakerNameInput {\n      border-radius: 0.5em;\n      border: 1px solid #7c7676;\n      width: 100%;\n      padding: 4px 2px;\n\n      &:focus {\n        border-color: #6ba7a8;\n        outline: none;\n      }\n    }\n  }\n\n  .speakerActions {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n  }\n  .edit,\n  .delete {\n    width: 16px;\n\n    &:hover {\n      cursor: pointer;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"singleSpeakerWrapper": `styles_singleSpeakerWrapper__Ee4FZ`,
	"speakerInfo": `styles_speakerInfo__62iG-`,
	"image": `styles_image__F9mug`,
	"speakerNameInput": `styles_speakerNameInput__XbBSH`,
	"speakerActions": `styles_speakerActions__bkCeC`,
	"edit": `styles_edit__LpPdc`,
	"delete": `styles_delete__8JLdY`
};
export default ___CSS_LOADER_EXPORT___;
